import { render, staticRenderFns } from "./CollectDetailNew.vue?vue&type=template&id=f9e27c8a&scoped=true&"
import script from "./CollectDetailNew.vue?vue&type=script&lang=js&"
export * from "./CollectDetailNew.vue?vue&type=script&lang=js&"
import style0 from "./CollectDetailNew.vue?vue&type=style&index=0&id=f9e27c8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9e27c8a",
  null
  
)

export default component.exports